<template>
    <div>
        <!-- 顶部标签导航 -->
        <el-tabs v-model="activeTab" type="card" tab-position="top" class="carousel-tabs" @tab-click="handleTabClick">
            <el-tab-pane label="积分规则列表" name="manage"></el-tab-pane>
            <el-tab-pane label="积分设置" name="setting"></el-tab-pane>
        </el-tabs>

        <!-- 积分设置页面 -->
        <div v-if="activeTab === 'setting'">
            <div class="carousel-banner">
                <div class="carousel-banner-title">积分设置</div>
                <div class="carousel-banner-desc">积分规则设置</div>
            </div>
            <el-card class="carousel-setting-card">

                <div class="form-section-title">基础设置</div>
                <el-form label-width="120px" style="max-width: 500px; margin: 0 auto;">

                    <!-- 新增一个输入框 标签是 每日最大积分 -->
                    <el-form-item label="每日最大积分">
                        <el-input v-model="pointmangerconf.dayMaxPoint" placeholder="请输入每日最大积分" />
                    </el-form-item>


                    <el-form-item label="定时清积分：" required>
                        <el-select v-model="pointmangerconf.Scheduledcleanup" placeholder="请选择定时清除积分的模式"
                            style="width: 220px;">
                            <el-option label="不清除" :value="0" />
                            <el-option label="每周一0点" :value="71" />
                            <el-option label="每周二0点" :value="72" />
                            <el-option label="每周三0点" :value="73" />
                            <el-option label="每周四0点" :value="74" />
                            <el-option label="每周五0点" :value="75" />
                            <el-option label="每周六0点" :value="76" />
                            <el-option label="每周日0点" :value="77" />
                            <el-option label="每月1号0点" :value="1" />
                            <el-option label="每月2号0点" :value="2" />
                            <el-option label="每月3号0点" :value="3" />
                            <el-option label="每月4号0点" :value="4" />
                            <el-option label="每月5号0点" :value="5" />
                            <el-option label="每月6号0点" :value="6" />
                            <el-option label="每月7号0点" :value="7" />
                            <el-option label="每月8号0点" :value="8" />
                            <el-option label="每月9号0点" :value="9" />
                            <el-option label="每月10号0点" :value="10" />
                            <el-option label="每月11号0点" :value="11" />
                            <el-option label="每月12号0点" :value="12" />
                            <el-option label="每月13号0点" :value="13" />
                            <el-option label="每月14号0点" :value="14" />
                            <el-option label="每月15号0点" :value="15" />
                            <el-option label="每月16号0点" :value="16" />
                            <el-option label="每月17号0点" :value="17" />
                            <el-option label="每月18号0点" :value="18" />
                            <el-option label="每月19号0点" :value="19" />
                            <el-option label="每月20号0点" :value="20" />
                            <el-option label="每月21号0点" :value="21" />
                            <el-option label="每月22号0点" :value="22" />
                            <el-option label="每月23号0点" :value="23" />
                            <el-option label="每月24号0点" :value="24" />
                            <el-option label="每月25号0点" :value="25" />
                            <el-option label="每月26号0点" :value="26" />
                            <el-option label="每月27号0点" :value="27" />
                            <el-option label="每月28号0点" :value="28" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="潜水员积分：" required>
                        <el-select v-model="pointmangerconf.longsilenceclean" placeholder="请选择清除潜水的成员积分的模式"
                            style="width: 220px;">
                            <el-option label="不清除" :value="0" />
                            <el-option label="清除1天没发言的成员积分" :value="1" />
                            <el-option label="清除2天没发言的成员积分" :value="2" />
                            <el-option label="清除3天没发言的成员积分" :value="3" />
                            <el-option label="清除4天没发言的成员积分" :value="4" />
                            <el-option label="清除5天没发言的成员积分" :value="5" />
                            <el-option label="清除6天没发言的成员积分" :value="6" />
                            <el-option label="清除7天没发言的成员积分" :value="7" />
                            <el-option label="清除8天没发言的成员积分" :value="8" />
                            <el-option label="清除9天没发言的成员积分" :value="9" />
                            <el-option label="清除10天没发言的成员积分" :value="10" />
                            <el-option label="清除15天没发言的成员积分" :value="15" />
                            <el-option label="清除20天没发言的成员积分" :value="20" />
                            <el-option label="清除30天没发言的成员积分" :value="30" />
                            <el-option label="清除60天没发言的成员积分" :value="60" />
                            <el-option label="清除90天没发言的成员积分" :value="90" />
                            <el-option label="清除180天没发言的成员积分" :value="180" />
                            <el-option label="清除360天没发言的成员积分" :value="360" />
                        </el-select>
                    </el-form-item>






                    <el-form-item>
                        <el-button type="primary" class="big-submit-btn" @click="saveSetting">提交</el-button>
                    </el-form-item>


                </el-form>
            </el-card>
        </div>

        <!-- 轮播广告列表页面 -->
        <div v-else>
            <!-- 原有内容保持不变 -->
            <div class="auto-reply">
                <div class="search-section">
                    <el-form :inline="true" :model="searchForm" class="demo-form-inline">

                        <el-form-item label="积分类型">
                            <el-select v-model="searchForm.ruleType" placeholder="请选择积分类型" clearable size="large"
                                style="width: 200px">
                                <el-option v-for="(label, value) in ruleTypeLabelMap" :key="value" :label="label"
                                    :value="value" />

                            </el-select>
                        </el-form-item>

                        <el-form-item label="状态">
                            <el-select v-model="searchForm.isEnable" placeholder="请选择状态" clearable size="large"
                                style="width: 120px">
                                <el-option label="启用" :value="1" />
                                <el-option label="禁用" :value="0" />
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <div class="button-group">
                                <el-button type="primary" @click="onSearch" size="large">
                                    <el-icon>
                                        <Search />
                                    </el-icon>
                                    搜索
                                </el-button>
                                <el-button @click="resetSearch" size="large">
                                    <el-icon>
                                        <Refresh />
                                    </el-icon>
                                    重置
                                </el-button>
                                <el-button type="success" @click="showCreateDialog" size="large">
                                    <el-icon>
                                        <Plus />
                                    </el-icon>
                                    新增积分规则
                                </el-button>
                                <el-button type="warning" @click="handleImport" size="large">
                                    <el-icon>
                                        <Upload />
                                    </el-icon>
                                    导入
                                </el-button>
                                <el-button type="info" @click="handleExport" size="large">
                                    <el-icon>
                                        <Download />
                                    </el-icon>
                                    导出
                                </el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>



                <el-divider></el-divider>

                <!-- 数据表格 -->
                <el-table :data="tableData" style="width: 100%" v-loading="loading">



                    <el-table-column label="规则内容" min-width="80">
                        <template #default="scope">
                            <el-text>{{ getRuleDesc(scope.row) }}</el-text>
                        </template>
                    </el-table-column>






                    <el-table-column label="创建时间" min-width="120">
                        <template #default="scope">
                            <el-text>{{ getloacltime(scope.row.createTime) }}</el-text>
                        </template>
                    </el-table-column>

                    <el-table-column prop="isEnable" label="状态" width="100">
                        <template #default="scope">
                            <el-switch v-model="scope.row.isEnable" :active-value="1" :inactive-value="0"
                                @change="handleStatusChange(scope.row)">
                            </el-switch>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="280" fixed="right">
                        <template #default="scope">
                            <el-button type="primary" size="small" @click="handleEdit(scope.row)">
                                <el-icon>
                                    <Edit />
                                </el-icon>
                                编辑
                            </el-button>
                            <el-button type="danger" size="small" @click="handleDelete(scope.row)">
                                <el-icon>
                                    <Delete />
                                </el-icon>
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页组件 -->
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>

                <!-- 新增/编辑对话框 -->
                <el-dialog v-model="dialogVisible" :title="dialogType === 'create' ? '新增积分规则' : '编辑积分规则'" width="900px"
                    :close-on-click-modal="false" destroy-on-close>
                    <el-form ref="formRef" :model="form" :rules="rules" label-width="140px" label-position="right"
                        class="auto-reply-form">



                        <!-- 自动回复类型 -->
                        <el-form-item prop="ruleType" label-width="10px">
                            <div class="reply-type-horizontal">
                                <div class="type-select-container">
                                    <span style="white-space: nowrap; margin-right: 10px;">积分类型</span>
                                    <el-select v-model="form.ruleType" placeholder="请选择积分类型" style="width: 250px;"
                                        popper-class="reply-type-dropdown">

                                        <el-option v-for="(label, value) in ruleTypeLabelMap" :key="value"
                                            :label="label" :value="value" />


                                    </el-select>
                                </div>
                            </div>
                        </el-form-item>


                        <!-- 签到相关组件，仅在 ruleType 为 sign 时显示 -->
                        <template v-if="form.ruleType === 'sign'">

                            <el-form-item prop="ruleType" label-width="10px">
                                <div class="reply-type-horizontal">
                                    <div class="type-select-container">
                                        <span style="white-space: nowrap; margin-right: 10px;">积分增减</span>
                                        <el-select v-model="form.pointDirect" placeholder="增加" style="width: 250px;"
                                            popper-class="reply-type-dropdown">
                                            <el-option label="减少" :value="-1"></el-option>
                                            <el-option label="增加" :value="1"></el-option>

                                        </el-select>
                                    </div>
                                </div>
                            </el-form-item>




                            <el-form-item prop="pointNum" label-width="10px">

                                <div class="condition-input-group">
                                    <span style="white-space: nowrap; margin-right: 10px;">积分数量</span>
                                    <el-input v-model="form.pointNum" placeholder="请输入一个大于等于0的整数"
                                        style="max-width: 250px;" />
                                </div>
                            </el-form-item>




                            <el-form-item prop="ruleContent.signWord" label-width="10px">

                                <div class="condition-input-group">
                                    <span style="white-space: nowrap; margin-right: 10px;">签到关键词</span>
                                    <div class="keyword-tags-input">
                                        <el-tag v-for="tag in form.ruleContent.signWord" :key="tag" closable
                                            :disable-transitions="false" @close="handleKeywordTagClose(tag)">
                                            {{ tag }}
                                        </el-tag>
                                        <input type="text" class="keyword-new-tag-input"
                                            v-model="form.ruleContent.signWord_input"
                                            @keyup.enter="handleKeywordInputConfirm" placeholder="输入后按回车" />
                                    </div>
                                </div>
                            </el-form-item>



                            <el-form-item prop="ruleType" label-width="10px">
                                <div class="reply-type-horizontal">
                                    <div class="type-select-container">
                                        <span style="white-space: nowrap; margin-right: 10px;">删除签到消息</span>
                                        <el-select v-model="form.ruleContent.deleteMemo" placeholder="请选择删除时间"
                                            style="width: 250px;" popper-class="reply-type-dropdown">

                                            <el-option label="不删除" value="0"></el-option>

                                            <el-option label="3秒后删除" value="3"></el-option>
                                            <el-option label="5秒后删除" value="5"></el-option>
                                            <el-option label="10秒后删除" value="10"></el-option>
                                            <el-option label="30秒后删除" value="30"></el-option>
                                            <el-option label="60秒后删除" value="60"></el-option>
                                            <el-option label="90秒后删除" value="90"></el-option>

                                            <el-option label="5分钟后删除" value="300"></el-option>
                                            <el-option label="10分钟后删除" value="600"></el-option>
                                            <el-option label="15分钟后删除" value="900"></el-option>
                                            <el-option label="30分钟后删除" value="1800"></el-option>
                                            <el-option label="60分钟后删除" value="3600"></el-option>

                                            <el-option label="2小时后删除" value="7200"></el-option>
                                            <el-option label="4小时后删除" value="14400"></el-option>
                                            <el-option label="6小时后删除" value="21600"></el-option>
                                            <el-option label="8小时后删除" value="28800"></el-option>
                                            <el-option label="10小时后删除" value="36000"></el-option>
                                            <el-option label="12小时后删除" value="43200"></el-option>
                                            <el-option label="24小时后删除" value="86400"></el-option>


                                        </el-select>
                                    </div>
                                </div>
                            </el-form-item>



                            <el-form-item prop="signMsgType" label-width="10px">
                                <div class="reply-type-horizontal">
                                    <div class="type-select-container">
                                        <span style="white-space: nowrap; margin-right: 10px;">签到成功提示</span>
                                        <el-select v-model="form.ruleContent.signMsgType" placeholder="请选择回复类型"
                                            style="width: 250px;" popper-class="reply-type-dropdown">
                                            <el-option label="文本内容" value="text"></el-option>
                                            <el-option label="图片" value="photo"></el-option>
                                            <el-option label="视频" value="video"></el-option>
                                        </el-select>
                                    </div>
                                    <div class="media-url-container"
                                        v-if="['photo', 'video'].includes(form.ruleContent.signMsgType)">
                                        <span
                                            style="white-space: nowrap; margin-right: 10px; color: #606266; font-size: 14px;">
                                            {{ { photo: '图片', video: '视频' }[form.ruleContent.signMsgType] }}地址：
                                        </span>
                                        <el-input v-model="form.ruleContent.fileUrl"
                                            :placeholder="`请输入${{ photo: '图片', video: '视频' }[form.ruleContent.signMsgType]}的URL地址`"
                                            style="flex: 1; min-width: 200px;" />
                                    </div>
                                </div>
                            </el-form-item>




                            <el-form-item prop="ruleContent.signSuccessHtml" label="签到成功提示" label-width="120px">
                                <div :key="editorSignKey">
                                    <div class="html-editor">
                                        <!-- 简单的 HTML 工具栏 -->
                                        <div class="html-toolbar">
                                            <button @click="insertHtml('<b>', '</b>')" type="button" title="加粗">
                                                <strong>B</strong>
                                            </button>
                                            <button @click="insertHtml('<i>', '</i>')" type="button" title="斜体">
                                                <em>I</em>
                                            </button>
                                            <button @click="insertHtml('<u>', '</u>')" type="button" title="下划线">
                                                <u>U</u>
                                            </button>
                                            <button @click="insertHtml('<br>')" type="button" title="换行">
                                                换行
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="insertHtml('<h1>', '</h1>')" type="button" title="标题1">
                                                H1
                                            </button>
                                            <button @click="insertHtml('<h2>', '</h2>')" type="button" title="标题2">
                                                H2
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="insertHtml('<ul><li>', '</li></ul>')" type="button"
                                                title="无序列表">
                                                • 列表
                                            </button>
                                            <button @click="insertHtml('<ol><li>', '</li></ol>')" type="button"
                                                title="有序列表">
                                                1. 列表
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="toggleMode" type="button"
                                                :title="isSourceMode ? '切换到可视化模式' : '切换到源码模式'"
                                                :class="{ 'is-active': isSourceMode }">
                                                {{ isSourceMode ? '可视' : '源码' }}
                                            </button>
                                        </div>
                                        <!-- 编辑器内容区域 -->
                                        <div class="editor-content-area">
                                            <!-- 可视化编辑模式 -->
                                            <div v-if="!isSourceMode" ref="visualEditor" class="visual-editor"
                                                contenteditable="true" @input="handleVisualInput"
                                                @compositionstart="handleCompositionStart"
                                                @compositionend="handleCompositionEnd" @paste="handlePaste"
                                                @keydown="handleKeydown">
                                            </div>
                                            <!-- 源码编辑模式 -->
                                            <el-input v-if="isSourceMode" ref="htmlTextarea"
                                                v-model="form.ruleContent.signSuccessHtml" type="textarea" :rows="8"
                                                placeholder="请输入签到成功提示，支持HTML标签..." class="html-textarea" />
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>

                            <!-- 附加按钮 -->
                            <el-form-item prop="buttons" label="附加按钮" label-width="80px">
                                <!-- 按钮行列表 -->
                                <div v-if="form.ruleContent.signMsgBtnList.length > 0" class="button-rows-list">
                                    <div v-for="(row, rowIndex) in form.ruleContent.signMsgBtnList"
                                        :key="`row-${rowIndex}-${JSON.stringify(row)}`" class="button-row-wrapper"
                                        @dragover="handleDragOver" @drop="handleDrop($event, rowIndex)"
                                        :class="{ 'drag-over': draggedRowIndex !== null && draggedRowIndex !== rowIndex }">
                                        <!-- 灰色按钮容器 -->
                                        <div class="gray-buttons-container">
                                            <div v-for="(button, btnIndex) in row" :key="btnIndex" class="button-item">
                                                {{ button.btnText || '按钮' }}
                                                <div class="button-actions">
                                                    <div class="button-action-icon edit-icon"
                                                        @click="editButton(rowIndex, btnIndex)" title="编辑按钮">
                                                        <el-icon>
                                                            <Edit />
                                                        </el-icon>
                                                    </div>
                                                    <div class="button-action-icon delete-icon"
                                                        @click="removeButton(rowIndex, btnIndex)" title="删除按钮">
                                                        <el-icon>
                                                            <Delete />
                                                        </el-icon>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 只有当行数 >= 1 时，才显示"本行新增一个按钮" -->
                                        <div v-if="form.ruleContent.signMsgBtnList.length >= 1"
                                            class="add-button-container">
                                            <button @click="showAddButtonDialog(rowIndex)" type="button"
                                                class="add-to-row-button">
                                                + 本行新增一个按钮
                                            </button>
                                        </div>
                                        <!-- 右侧拖拽图标 -->
                                        <div class="drag-icon-container" :title="'拖拽移动第' + (rowIndex + 1) + '行'"
                                            draggable="true" @dragstart="handleDragStart(rowIndex)"
                                            @dragend="handleDragEnd">
                                            <el-icon class="drag-icon">
                                                <Rank />
                                            </el-icon>
                                        </div>
                                    </div>
                                </div>

                                <!-- 新增一行按钮 -->
                                <div class="button-controls" v-if="form.msgType != 5">
                                    <button @click="showAddButtonDialog(-1)" type="button" class="add-row-button">
                                        + 新增一行按钮
                                    </button>
                                </div>
                            </el-form-item>

                            <!-- 添加按钮对话框 -->
                            <el-dialog v-model="buttonDialogVisible" :title="getDialogTitle()" width="400px"
                                :close-on-click-modal="false" destroy-on-close>
                                <el-form :model="buttonForm" :rules="buttonRules" ref="buttonFormRef"
                                    label-width="80px">
                                    <el-form-item label="按钮文字" prop="text">
                                        <el-input v-model="buttonForm.text" placeholder="请输入按钮文字" />
                                    </el-form-item>
                                    <el-form-item label="链接" prop="url">
                                        <el-input v-model="buttonForm.url" placeholder="请输入http://或https://开头的链接地址" />
                                    </el-form-item>
                                </el-form>
                                <template #footer>
                                    <div class="dialog-footer">
                                        <el-button @click="buttonDialogVisible = false">取消</el-button>
                                        <el-button type="primary" @click="confirmAddButton">确定</el-button>
                                    </div>
                                </template>
                            </el-dialog>




                            <el-form-item prop="ruleContent.signRepeatHtml" label="重复签到提示" label-width="120px">
                                <div :key="editorRepeatKey">
                                    <div class="html-editor">
                                        <!-- 简单的 HTML 工具栏 -->
                                        <div class="html-toolbar">
                                            <button @click="insertHtmlRepeat('<b>', '</b>')" type="button" title="加粗">
                                                <strong>B</strong>
                                            </button>
                                            <button @click="insertHtmlRepeat('<i>', '</i>')" type="button" title="斜体">
                                                <em>I</em>
                                            </button>
                                            <button @click="insertHtmlRepeat('<u>', '</u>')" type="button" title="下划线">
                                                <u>U</u>
                                            </button>
                                            <button @click="insertHtmlRepeat('<br>')" type="button" title="换行">
                                                换行
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="insertHtmlRepeat('<h1>', '</h1>')" type="button"
                                                title="标题1">
                                                H1
                                            </button>
                                            <button @click="insertHtmlRepeat('<h2>', '</h2>')" type="button"
                                                title="标题2">
                                                H2
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="insertHtmlRepeat('<ul><li>', '</li></ul>')" type="button"
                                                title="无序列表">
                                                • 列表
                                            </button>
                                            <button @click="insertHtmlRepeat('<ol><li>', '</li></ol>')" type="button"
                                                title="有序列表">
                                                1. 列表
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="toggleMode" type="button"
                                                :title="isSourceMode ? '切换到可视化模式' : '切换到源码模式'"
                                                :class="{ 'is-active': isSourceMode }">
                                                {{ isSourceMode ? '可视' : '源码' }}
                                            </button>
                                        </div>
                                        <!-- 编辑器内容区域 -->
                                        <div class="editor-content-area">
                                            <!-- 可视化编辑模式 -->
                                            <div v-if="!isSourceMode" ref="visualEditorRepeat" class="visual-editor"
                                                contenteditable="true" @input="handleVisualInputRepeat"
                                                @compositionstart="handleCompositionStartRepeat"
                                                @compositionend="handleCompositionEndRepeat" @paste="handlePasteRepeat"
                                                @keydown="handleKeydownRepeat">
                                            </div>
                                            <!-- 源码编辑模式 -->
                                            <el-input v-if="isSourceMode" ref="htmlTextareaRepeat"
                                                v-model="form.ruleContent.signRepeatHtml" type="textarea" :rows="8"
                                                placeholder="请输入重复签到提示，支持HTML标签..." class="html-textarea" />
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>



                            <el-form-item prop="ruleType" label-width="10px">
                                <div class="reply-type-horizontal">
                                    <div class="type-select-container">
                                        <span style="white-space: nowrap; margin-right: 10px;">删除提示消息</span>
                                        <el-select v-model="form.ruleContent.deleteTipMemo" placeholder="请选择删除时间"
                                            style="width: 250px;" popper-class="reply-type-dropdown">

                                            <el-option label="不删除" value="0"></el-option>

                                            <el-option label="3秒后删除" value="3"></el-option>
                                            <el-option label="5秒后删除" value="5"></el-option>
                                            <el-option label="10秒后删除" value="10"></el-option>
                                            <el-option label="30秒后删除" value="30"></el-option>
                                            <el-option label="60秒后删除" value="60"></el-option>
                                            <el-option label="90秒后删除" value="90"></el-option>

                                            <el-option label="5分钟后删除" value="300"></el-option>
                                            <el-option label="10分钟后删除" value="600"></el-option>
                                            <el-option label="15分钟后删除" value="900"></el-option>
                                            <el-option label="30分钟后删除" value="1800"></el-option>
                                            <el-option label="60分钟后删除" value="3600"></el-option>

                                            <el-option label="2小时后删除" value="7200"></el-option>
                                            <el-option label="4小时后删除" value="14400"></el-option>
                                            <el-option label="6小时后删除" value="21600"></el-option>
                                            <el-option label="8小时后删除" value="28800"></el-option>
                                            <el-option label="10小时后删除" value="36000"></el-option>
                                            <el-option label="12小时后删除" value="43200"></el-option>
                                            <el-option label="24小时后删除" value="86400"></el-option>


                                        </el-select>
                                    </div>
                                </div>
                            </el-form-item>








                        </template>


                        <!-- 发送文字、图片、视频、表情 -->
                        <template
                            v-if="form.ruleType === 'textContent' || form.ruleType === 'photoContent' || form.ruleType === 'videoContent' || form.ruleType === 'stickerContent'">

                            <el-form-item prop="ruleType" label-width="10px" v-if="form.ruleType === 'textContent'">
                                <div class="reply-type-horizontal">
                                    <div class="type-select-container">
                                        <span style="white-space: nowrap; margin-right: 10px;">文字长度限制</span>
                                        <el-select v-model="form.ruleContent.msgLength" placeholder="请选择文字长度限制"
                                            style="width: 250px;" popper-class="reply-type-dropdown">

                                            <el-option label="无要求" value="0"></el-option>

                                            <el-option label="文字长度大于2" value="2"></el-option>
                                            <el-option label="文字长度大于3" value="3"></el-option>
                                            <el-option label="文字长度大于4" value="4"></el-option>
                                            <el-option label="文字长度大于5" value="5"></el-option>
                                            <el-option label="文字长度大于10" value="10"></el-option>
                                            <el-option label="文字长度大于20" value="20"></el-option>
                                            <el-option label="文字长度大于30" value="30"></el-option>
                                            <el-option label="文字长度大于50" value="50"></el-option>
                                            <el-option label="文字长度大于100" value="100"></el-option>


                                        </el-select>
                                    </div>
                                </div>
                            </el-form-item>


                            <el-form-item prop="ruleType" label-width="10px">
                                <div class="reply-type-horizontal">
                                    <div class="type-select-container">
                                        <span style="white-space: nowrap; margin-right: 10px;">积分增减</span>
                                        <el-select v-model="form.pointDirect" placeholder="增加" style="width: 250px;"
                                            popper-class="reply-type-dropdown">
                                            <el-option label="减少" :value="-1"></el-option>
                                            <el-option label="增加" :value="1"></el-option>

                                        </el-select>
                                    </div>
                                </div>
                            </el-form-item>




                            <el-form-item prop="pointNum" label-width="10px">

                                <div class="condition-input-group">
                                    <span style="white-space: nowrap; margin-right: 10px;">积分数量</span>
                                    <el-input v-model="form.pointNum" placeholder="请输入一个大于等于0的整数"
                                        style="max-width: 250px;" />
                                </div>
                            </el-form-item>

                            <el-form-item prop="dayMaxPoint" label-width="10px">

                                <div class="condition-input-group">
                                    <span style="white-space: nowrap; margin-right: 10px;">每日最大积分</span>
                                    <el-input v-model="form.dayMaxPoint" placeholder="请输入一个大于等于0的整数"
                                        style="max-width: 220px;" />
                                </div>
                            </el-form-item>








                        </template>


                        <!-- 每日发言数、周发言数、月发言数、日发言排名、周发言排名、月发言排名 -->

                        <template
                            v-if="form.ruleType === 'dayMsgNum' || form.ruleType === 'weekMsgNum' || form.ruleType === 'monthMsgNum' || form.ruleType === 'dayMsgRank' || form.ruleType === 'weekMsgRank' || form.ruleType === 'monthMsgRank'">


                            <el-form-item prop="awardRule" label="奖励规则" label-width="80px"
                                v-if="form.ruleType === 'dayMsgNum' || form.ruleType === 'weekMsgNum' || form.ruleType === 'monthMsgNum'">
                                <div v-if="form.ruleContent.awardRule.length === 0" class="button-controls">
                                    <button @click="addAwardRule" type="button" class="add-row-button"
                                        style="width: 650px; margin-left: 2px;">
                                        + 新增奖励规则
                                    </button>
                                </div>
                                <div v-else>
                                    <div v-for="(item, idx) in form.ruleContent.awardRule" :key="idx"
                                        style="display: flex; align-items: center; margin-bottom: 10px;">
                                        <el-input v-model="item.msgNum" placeholder="发言数达到："
                                            style="width: 320px; height: 35px; margin-right: 10px;" size="small" />
                                        <el-input v-model="item.pointNum" placeholder="奖励积分："
                                            style="width: 320px; height: 35px; margin-right: 10px;" size="small" />
                                        <el-button type="danger" size="small"
                                            @click="removeAwardRule(idx)">删除</el-button>
                                    </div>
                                    <div class="button-controls">
                                        <button @click="addAwardRule" type="button" class="add-row-button"
                                            style="width: 650px; margin-left: 2px;">
                                            + 新增奖励规则
                                        </button>
                                    </div>
                                </div>
                            </el-form-item>

                            <el-form-item prop="awardRankRule" label="奖励规则" label-width="80px"
                                v-if="form.ruleType === 'dayMsgRank' || form.ruleType === 'weekMsgRank' || form.ruleType === 'monthMsgRank'">

                                <div v-for="(item, idx) in form.ruleContent.awardRule" :key="idx"
                                    style="display: flex; align-items: center; margin-bottom: 10px;">
                                    <span style="white-space: nowrap; margin-right: 10px;">发言数排名：</span>
                                    <el-input v-model="item.minRank" style="width: 60px; margin-right: 5px;"
                                        size="small" />
                                    <span style="margin: 0 5px;">~</span>
                                    <el-input v-model="item.maxRank" style="width: 60px; margin-right: 20px;"
                                        size="small" />
                                    <span style="white-space: nowrap; margin-right: 10px;">奖励积分：</span>
                                    <el-input v-model="item.pointNum" style="width: 120px; margin-right: 10px;"
                                        size="small" />
                                    <el-button type="text" style="color: #409EFF;"
                                        @click="removeAwardRule(idx)">删除</el-button>
                                </div>
                                <div class="button-controls" style="text-align: center;">
                                    <button @click="addAwardRule" type="button" class="add-row-button"
                                        style="width: 650px; margin-left: 2px;">
                                        + 新增奖励规则
                                    </button>
                                </div>




                            </el-form-item>



                            <el-form-item prop="ruleContent.signRepeatHtml" label="奖励提示" label-width="120px"
                                v-if="form.ruleType === 'dayMsgNum' || form.ruleType === 'weekMsgNum' || form.ruleType === 'monthMsgNum'">
                                <div :key="editorAwardKey">
                                    <div class="html-editor">
                                        <div class="html-toolbar">
                                            <button @click="insertHtmlAward('<b>', '</b>')" type="button" title="加粗">
                                                <strong>B</strong>
                                            </button>
                                            <button @click="insertHtmlAward('<i>', '</i>')" type="button" title="斜体">
                                                <em>I</em>
                                            </button>
                                            <button @click="insertHtmlAward('<u>', '</u>')" type="button" title="下划线">
                                                <u>U</u>
                                            </button>
                                            <button @click="insertHtmlAward('<br>')" type="button" title="换行">
                                                换行
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="insertHtmlAward('<h1>', '</h1>')" type="button" title="标题1">
                                                H1
                                            </button>
                                            <button @click="insertHtmlAward('<h2>', '</h2>')" type="button" title="标题2">
                                                H2
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="insertHtmlAward('<ul><li>', '</li></ul>')" type="button"
                                                title="无序列表">
                                                • 列表
                                            </button>
                                            <button @click="insertHtmlAward('<ol><li>', '</li></ol>')" type="button"
                                                title="有序列表">
                                                1. 列表
                                            </button>
                                            <span class="divider">|</span>
                                            <button @click="toggleMode" type="button"
                                                :title="isSourceMode ? '切换到可视化模式' : '切换到源码模式'"
                                                :class="{ 'is-active': isSourceMode }">
                                                {{ isSourceMode ? '可视' : '源码' }}
                                            </button>
                                        </div>
                                        <div class="editor-content-area">
                                            <div v-if="!isSourceMode" ref="visualEditorAward" class="visual-editor"
                                                contenteditable="true" @input="handleVisualInputAward"
                                                @compositionstart="handleCompositionStartAward"
                                                @compositionend="handleCompositionEndAward" @paste="handlePasteAward"
                                                @keydown="handleKeydownAward">
                                            </div>
                                            <el-input v-if="isSourceMode" ref="htmlTextareaAward"
                                                v-model="form.ruleContent.awardHtml" type="textarea" :rows="8"
                                                placeholder="请输入奖励提示，支持HTML标签..." class="html-textarea" />
                                        </div>
                                    </div>
                                </div>



                            </el-form-item>


                            <el-form-item prop="ruleType" label-width="10px"
                                v-if="form.ruleType === 'dayMsgNum' || form.ruleType === 'weekMsgNum' || form.ruleType === 'monthMsgNum'">
                                <div class="reply-type-horizontal">
                                    <div class="type-select-container">
                                        <span style="white-space: nowrap; margin-right: 10px;">删除提示消息</span>
                                        <el-select v-model="form.ruleContent.deleteTipMemo" placeholder="请选择删除时间"
                                            style="width: 250px;" popper-class="reply-type-dropdown">

                                            <el-option label="不删除" value="0"></el-option>

                                            <el-option label="3秒后删除" value="3"></el-option>
                                            <el-option label="5秒后删除" value="5"></el-option>
                                            <el-option label="10秒后删除" value="10"></el-option>
                                            <el-option label="30秒后删除" value="30"></el-option>
                                            <el-option label="60秒后删除" value="60"></el-option>
                                            <el-option label="90秒后删除" value="90"></el-option>

                                            <el-option label="5分钟后删除" value="300"></el-option>
                                            <el-option label="10分钟后删除" value="600"></el-option>
                                            <el-option label="15分钟后删除" value="900"></el-option>
                                            <el-option label="30分钟后删除" value="1800"></el-option>
                                            <el-option label="60分钟后删除" value="3600"></el-option>

                                            <el-option label="2小时后删除" value="7200"></el-option>
                                            <el-option label="4小时后删除" value="14400"></el-option>
                                            <el-option label="6小时后删除" value="21600"></el-option>
                                            <el-option label="8小时后删除" value="28800"></el-option>
                                            <el-option label="10小时后删除" value="36000"></el-option>
                                            <el-option label="12小时后删除" value="43200"></el-option>
                                            <el-option label="24小时后删除" value="86400"></el-option>


                                        </el-select>
                                    </div>
                                </div>
                            </el-form-item>







                            <el-form-item prop="minMsgNum" label-width="10px"
                                v-if="form.ruleType === 'dayMsgRank' || form.ruleType === 'weekMsgRank' || form.ruleType === 'monthMsgRank'">

                                <div class="condition-input-group">
                                    <span style="white-space: nowrap; margin-right: 10px;">最少发言量</span>
                                    <el-input v-model="form.ruleContent.minMsgNum" placeholder="请输入一个大于等于0的整数"
                                        style="max-width: 220px;" />
                                </div>
                            </el-form-item>










                        </template>






                    </el-form>
                    <template #footer>
                        <div class="dialog-footer">
                            <el-button @click="dialogVisible = false">取消</el-button>
                            <el-button type="primary" @click="handleSubmit">确定</el-button>
                        </div>
                    </template>
                </el-dialog>

                <!-- 导入对话框 -->
                <el-dialog v-model="importVisible" title="导入轮播广告（JSON格式）" width="600px">
                    <el-input type="textarea" v-model="jsonInput" :rows="8"
                        placeholder="可粘贴 JSON 或拖拽上传 .json 文件，将自动提取数组数据" style="margin-bottom: 16px;" />
                    <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: center;">
                        <el-button size="small" @click="toggleJsonFormat" :disabled="!jsonInput">
                            <el-icon>
                                <ViewIcon />
                            </el-icon>
                            {{ isFormatted ? '压缩显示' : '格式化显示' }}
                        </el-button>
                        <span v-if="previewCount > 0" style="color: #67c23a; font-size: 14px;">
                            已识别到 {{ previewCount }} 条数据
                        </span>
                    </div>
                    <el-upload :show-file-list="false" accept=".json,application/json" :before-upload="handleJsonFile"
                        drag class="json-upload-drag">
                        <el-icon class="el-icon--upload">
                            <Upload />
                        </el-icon>
                        <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                        </div>
                        <template #tip>
                            <div class="el-upload__tip">
                                支持粘贴或上传 JSON 文件，格式如：{ code, data: { records: [...] } }<br>
                                将自动提取数组数据并压缩显示，字段需与导出格式一致。
                            </div>
                        </template>
                    </el-upload>
                    <template #footer>
                        <div class="dialog-footer">
                            <el-button @click="importVisible = false">取消</el-button>
                            <el-button type="primary" @click="confirmImport" :loading="importLoading"
                                :disabled="!jsonInput">
                                {{ importLoading ? '正在导入...' : '确定导入' }}
                            </el-button>
                        </div>
                    </template>
                </el-dialog>

                <!-- 媒体组管理对话框 -->
                <el-dialog v-model="mediaGroupDialogVisible" title="图片或视频" width="600px" :close-on-click-modal="false">
                    <div class="media-group-manager">
                        <div class="media-item" v-for="(item, index) in tempMediaGroup" :key="index">
                            <div class="media-item-content">
                                <span class="media-index">{{ index + 1 }}.</span>
                                <el-select v-model="item.mediaType" style="width: 100px;" size="small">
                                    <el-option label="图片" value="photo"></el-option>
                                    <el-option label="视频" value="video"></el-option>
                                </el-select>
                                <el-input v-model="item.fileUrl"
                                    :placeholder="`请输入${item.mediaType === 'photo' ? '图片' : '视频'}URL地址`"
                                    style="flex: 1; margin: 0 10px;" size="small" />
                                <el-button type="danger" size="small" @click="removeMediaItem(index)" :icon="Delete">
                                    删除
                                </el-button>
                            </div>
                        </div>

                        <div class="add-media-section">
                            <el-button type="primary" size="small" @click="addMediaItem" :icon="Plus">
                                新增一行
                            </el-button>
                        </div>
                    </div>

                    <template #footer>
                        <div class="dialog-footer">
                            <el-button @click="cancelMediaGroupEdit">取消</el-button>
                            <el-button type="primary" @click="confirmMediaGroupEdit">确定</el-button>
                        </div>
                    </template>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import { Search, Refresh, Plus, Edit, Delete, Upload, Download, Rank, View as ViewIcon } from '@element-plus/icons-vue'
import api from '@/services/api'

export default {
    name: 'AutoReply',
    components: {
        Search,
        Refresh,
        Plus,
        Edit,
        Delete,
        Upload,
        Download,
        Rank,
        ViewIcon
    },
    data() {
        return {
            searchForm: {
                ruleType: '',
                isEnable: ''
            },
            pointmangerconf: {
                dayMaxPoint: 0,
                Scheduledcleanup: 0,/////定期清理积分
                longsilenceclean: 0/////清除长期静默的成员积分
            },
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            statsVisible: false,
            stats: {
                overview: null
            },
            dialogVisible: false,
            dialogType: 'create',
            importVisible: false,
            importLoading: false,
            selectedFile: null,
            currentUserInfo: {
                userid: null,
                groupid: null,
                userBot: null
            },
            form: {
                ruleType: 'sign',
                pointDirect: 1,
                pointNum: 0,
                dayMaxPoint: -1,
                ruleContent: {
                    signWord: ['签到'],
                    signWord_input: '',
                    deleteMemo: "0",
                    signMsgType: "text",
                    signMsgBtnList: [],
                    fileUrl: null,
                    signSuccessHtml: '签到成功，您是第{signRank}位签到成员，{pointAlias}加{pointNum}<br>您当前的{pointAlias}为{pointBalance}<br>',
                    deleteTipMemo: "0",
                    signRepeatHtml: '今天您已签过到，无需重复签到。<br>'
                },
                isEnable: 1,
                userBot: null,
                groupid: null,
                userid: null
            },
            rules: {
                msgContent: [
                    {
                        required: true,
                        message: '请输入轮播文本内容',
                        trigger: 'blur',
                        validator: (rule, value, callback) => {

                            if (!value || value.trim() === '') {
                                callback(new Error('请输入轮播文本内容'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                endTime: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && this.form.startTime && value <= this.form.startTime) {
                                callback(new Error('结束时间必须晚于开始时间'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ]
            },
            isSourceMode: false,
            isComposing: false,
            isComposingRepeat: false,
            isComposingAward: false,
            shouldRestoreCaret: false,
            updateTimer: null,
            updateTimerRepeat: null,
            updateTimerAward: null,
            // 按钮对话框相关
            buttonDialogVisible: false,
            buttonForm: {
                text: '',
                url: ''
            },
            currentRowIndex: -1,
            editingButtonRowIndex: -1, // 正在编辑的按钮行索引
            editingButtonIndex: -1, // 正在编辑的按钮索引
            // 拖拽相关
            draggedRowIndex: null,
            buttonRules: {
                text: [
                    { required: true, message: '请输入按钮文字', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: '请输入链接地址', trigger: 'blur' },
                    {
                        pattern: /^https?:\/\/.+/,
                        message: '链接地址必须以http://或https://开头',
                        trigger: 'blur'
                    }
                ]
            },
            // 动态表单模板
            ruleTypeTemplates: {
                sign: {
                    signWord: ['签到'],
                    signWord_input: '',
                    deleteMemo: "0",
                    signMsgType: "text",
                    signMsgBtnList: [],
                    fileUrl: null,
                    signSuccessHtml: '签到成功，您是第{signRank}位签到成员，{pointAlias}加{pointNum}<br>您当前的{pointAlias}为{pointBalance}<br>',
                    deleteTipMemo: "0",
                    signRepeatHtml: '今天您已签过到，无需重复签到。<br>'
                },
                textContent: {
                    msgLength: 2
                },
                photoContent: {},
                videoContent: {},
                stickerContent: {},
                dayMsgNum: {
                    awardRule: [
                        {
                            msgNum: "100",
                            pointNum: "10"
                        }
                    ],
                    deleteMemo: "60-m",
                    awardHtml: '恭喜{member}，您今日发言数量达到{msgNum}，获得{pointNum}{pointAlias}奖励,今日总共已获得积分奖励{awardPointNum}<br>您当前的{pointAlias}为{pointBalance}<br>'
                },
                weekMsgNum: {
                    awardRule: [
                        {
                            msgNum: "500",
                            pointNum: "50"
                        }
                    ],
                    deleteMemo: "60-m",
                    awardHtml: '恭喜{member}，您本周发言数量达到{msgNum}，获得{pointNum}{pointAlias}奖励，本周总共已获得积分奖励{awardPointNum}<br>您当前的{pointAlias}为{pointBalance}<br>'
                },
                monthMsgNum: {
                    awardRule: [
                        {
                            msgNum: "5000",
                            pointNum: "500"
                        }
                    ],
                    deleteMemo: "60-m",
                    awardHtml: '恭喜{member}，您本月发言数量达到{msgNum}，获得{pointNum}{pointAlias}奖励，本月总共已获得积分奖励{awardPointNum}<br>您当前的{pointAlias}为{pointBalance}<br>'
                },
                dayMsgRank: {
                    minMsgNum: "100",
                    awardRule: [
                        {
                            minRank: "1",
                            maxRank: "10",
                            pointNum: "10"
                        }
                    ]
                },
                weekMsgRank: {
                    minMsgNum: "100",
                    awardRule: [
                        {
                            minRank: "1",
                            maxRank: "10",
                            pointNum: "10"
                        }
                    ]
                },
                monthMsgRank: {
                    awardRule: [
                        {
                            minRank: "1",
                            maxRank: "10",
                            pointNum: "10"
                        }
                    ]
                }
            },
            activeTab: 'manage',
            setting: {
                enabled: true,
                interval: 5,
                mode: 'send_and_pin',
                cancelLastPin: false,
                deleteLastAd: false
            },
            jsonInput: '',
            previewCount: 0,
            isFormatted: false,
            mediaGroupDialogVisible: false,
            tempMediaGroup: [],
            ruleTypeLabelMap: {
                stickerContent: '群成员发送贴纸消息',
                videoContent: '群成员发送视频消息',
                photoContent: '群成员发送图片消息',
                sign: '群成员每天首次签到',
                textContent: '群成员发送文字消息',
                dayMsgNum: '日发言数量奖励积分',
                weekMsgNum: '周发言数量奖励积分',
                monthMsgNum: '月发言数量奖励积分',
                dayMsgRank: '日发言排名奖励积分',
                weekMsgRank: '周发言排名奖励积分',
                monthMsgRank: '月发言排名奖励积分'
            },
            editorAwardKey: 0,
            editorSignKey: 0,
            editorRepeatKey: 0
        }
    },
    computed: {
        vuexUser() {
            return this.$store.state.user;
        }
    },
    watch: {
        vuexUser: {
            handler(newUser) {
                if (newUser) {
                    this.loadUserInfo(newUser);
                }
            },
            deep: true,
            immediate: true
        },
        jsonInput: {
            handler(newValue) {
                if (newValue && newValue.trim()) {
                    this.processJsonInput(newValue);
                } else {
                    this.previewCount = 0;
                }
            },
            immediate: false
        },
        'form.ruleType'(val) {
            // 确保切换类型时重建表单结构
            this.rebuildFormByRuleType(val);
            if (val === 'sign') {
                this.editorSignKey++;
                this.editorRepeatKey++;
                this.$nextTick(() => {
                    this.setVisualEditorContent(this.form.ruleContent.signSuccessHtml || '');
                    this.setVisualEditorContentRepeat(this.form.ruleContent.signRepeatHtml || '');
                });
            }
            if (
                val === 'dayMsgNum' ||
                val === 'weekMsgNum' ||
                val === 'monthMsgNum' ||
                val === 'dayMsgRank' ||
                val === 'weekMsgRank' ||
                val === 'monthMsgRank'
            ) {
                this.editorAwardKey++;
                this.$nextTick(() => {
                    this.setVisualEditorContentAward(this.form.ruleContent.awardHtml || '');
                });
            }
        },
    },
    methods: {
        addAwardRule() {
            if (!this.form.ruleContent.awardRule) {
                this.form.ruleContent.awardRule = [];
            }
            this.form.ruleContent.awardRule.push({ msgNum: '', pointNum: '' });
        },
        removeAwardRule(idx) {
            this.form.ruleContent.awardRule.splice(idx, 1);
        },
        // 签到关键词
        handleKeywordTagClose(tag) {
            // 删除指定标签
            const idx = this.form.ruleContent.signWord.indexOf(tag);
            if (idx !== -1) {
                this.form.ruleContent.signWord.splice(idx, 1);
            }
        },
        handleKeywordInputConfirm() {
            // 新增标签
            let inputValue = (this.form.ruleContent.signWord_input || '').trim();
            if (inputValue && !this.form.ruleContent.signWord.includes(inputValue)) {
                this.form.ruleContent.signWord.push(inputValue);
            }
            this.form.ruleContent.signWord_input = '';
        },

        getRuleDesc(row) {
            let label = this.getRuleTypeLabel(row.ruleType);
            let extra = '';
            if (
                row.ruleType === 'textContent' &&
                row.ruleContent &&
                typeof row.ruleContent.msgLength === 'number' &&
                row.ruleContent.msgLength > 0
            ) {
                extra = `，且文字长度需大于 ${row.ruleContent.msgLength}`;
            }
            return `${label}${extra}，积分${row.pointDirect === 1 ? '增加' : '减少'}${row.pointNum}`;
        },



        handleTabClick(tab) {
            // console.log('标签点击:', JSON.stringify(tab));
            if (tab.paneName == 'manage') {
                this.fetchData()
            } else if (tab.paneName == 'setting') {
                this.fetchSetting()
            }
        },

        fetchSetting() {
            /////////调用group表的对应api接口获取群的配置
            api.getGroupById(this.currentUserInfo.groupId).then(res => {
                if (res.data.pointmangerconf && res.data.pointmangerconf != null && res.data.pointmangerconf != '') {
                    this.pointmangerconf = res.data.pointmangerconf;
                    // console.log('获取配置:', JSON.stringify(res.data.pointmangerconf));
                }
            })
        },


        saveSetting() {
            // console.log('提交配置:', JSON.stringify(this.pointmangerconf));
            api.updatePointmangerconfById(this.currentUserInfo.groupId, {
                pointmangerconf: this.pointmangerconf
            }).then(res => {
                if (res.data.code == 0) {
                    this.$message.success('邀请配置保存成功');
                    this.fetchSetting();
                } else {
                    this.$message.error(res.data.message || '保存失败');
                }
            }).catch(error => {
                this.$message.error('保存失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            });
        },


        loadUserInfo(user) {
            this.currentUserInfo.userId = user.userId;
            this.currentUserInfo.groupId = user.groupId;
            this.currentUserInfo.userBot = user.userBot;
        },
        onSearch() {
            this.currentPage = 1
            this.fetchData()
        },
        resetSearch() {
            this.searchForm = {
                ruleType: '',
                isEnable: ''
            }
            this.currentPage = 1
            this.fetchData()
        },
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                }



                if (this.searchForm.ruleType !== '') {
                    params.ruleType = this.searchForm.ruleType
                }
                if (this.searchForm.isEnable !== '') {
                    params.isEnable = this.searchForm.isEnable
                }

                const response = await api.getPointsManagerList(params)

                if (response.data.code === 0) {
                    this.tableData = response.data.data.records
                    this.total = response.data.data.total
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('获取轮播广告失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        async fetchStats() {
            try {
                this.loading = true
                const response = await api.getAutoReplyStats()

                if (response.data.code === 0) {
                    this.stats = response.data.data
                    this.statsVisible = true
                } else {
                    this.$message.error(response.data.message || '获取统计信息失败')
                }
            } catch (error) {
                console.error('获取统计信息失败:', error)
                this.$message.error('获取统计信息失败')
            } finally {
                this.loading = false
            }
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        },
        showCreateDialog() {
            this.dialogType = 'create'
            this.form = {
                ruleType: 'sign',
                pointDirect: 1,
                pointNum: 0,
                dayMaxPoint: -1,
                ruleContent: {
                    signWord: ['签到'],
                    signWord_input: '',
                    deleteMemo: "0",
                    signMsgType: "text",
                    signSuccessHtml: '签到成功，您是第{signRank}位签到成员，{pointAlias}加{pointNum}<br>您当前的{pointAlias}为{pointBalance}<br>',
                    signMsgBtnList: [],
                    fileUrl: null,
                    deleteTipMemo: "0",
                    signRepeatHtml: '今天您已签过到，无需重复签到。<br>'
                },
                isEnable: 1,
                userBot: null,
                groupid: null,
                userid: null
            }
            this.editorSignKey++;
            this.editorRepeatKey++;
            this.editorAwardKey++;
            this.dialogVisible = true

            // 延迟清空编辑器内容，确保DOM已更新
            this.$nextTick(() => {
                this.setVisualEditorContent(this.form.ruleContent.signSuccessHtml || '');
                this.setVisualEditorContentRepeat(this.form.ruleContent.signRepeatHtml || '');
                this.setVisualEditorContentAward(this.form.ruleContent.awardHtml || '');
            });
        },
        handleEdit(row) {
            this.dialogType = 'edit'
            this.form = { ...row }
            this.editorSignKey++;
            this.editorRepeatKey++;
            this.editorAwardKey++;

            // 确保 dayMaxPoint 字段存在
            if (this.form.dayMaxPoint === undefined) {
                this.form.dayMaxPoint = -1;
            }

            // 确保 ruleContent 结构完整
            if (!this.form.ruleContent) {
                this.form.ruleContent = {};
            }

            // 根据规则类型确保必要的字段存在
            if (this.form.ruleType === 'sign') {
                if (!this.form.ruleContent.signWord) {
                    this.form.ruleContent.signWord = ['签到'];
                }
                if (!this.form.ruleContent.signWord_input) {
                    this.form.ruleContent.signWord_input = '';
                }
            }

            // 处理时间字段 - 确保时间戳为数值型以供日期选择器使用
            if (this.form.startTime) {
                // 如果是字符串格式的时间戳，转换为数值
                if (typeof this.form.startTime === 'string') {
                    this.form.startTime = parseInt(this.form.startTime);
                }
                // 确保是有效的时间戳
                if (isNaN(this.form.startTime)) {
                    this.form.startTime = null;
                }
            }
            if (this.form.endTime) {
                // 如果是字符串格式的时间戳，转换为数值
                if (typeof this.form.endTime === 'string') {
                    this.form.endTime = parseInt(this.form.endTime);
                }
                // 确保是有效的时间戳
                if (isNaN(this.form.endTime)) {
                    this.form.endTime = null;
                }
            }

            this.dialogVisible = true

            // 延迟设置编辑器内容，确保DOM已更新
            this.$nextTick(() => {
                this.setVisualEditorContent(this.form.ruleContent.signSuccessHtml || '');
                this.setVisualEditorContentRepeat(this.form.ruleContent.signRepeatHtml || '');
                this.setVisualEditorContentAward(this.form.ruleContent.awardHtml || '');
            });
        },
        async handleDelete(row) {
            try {
                await this.$confirm('确定要删除这个轮播广告吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })

                const response = await api.deletePointsManager(row.id)
                if (response.data.code === 0) {
                    this.$message.success('删除成功')
                    this.fetchData()
                } else {
                    this.$message.error(response.data.message || '删除失败')
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除失败:', error)
                    this.$message.error('删除失败')
                }
            }
        },
        async handleStatusChange(row) {
            try {
                const response = await api.updatePointsManager(row.id, {
                    isEnable: row.isEnable,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                })
                if (response.data.code === 0) {
                    this.$message.success('状态更新成功')
                } else {
                    this.$message.error(response.data.message || '状态更新失败')
                    // 恢复原状态
                    row.isEnable = row.isEnable === 1 ? 0 : 1
                }
            } catch (error) {
                console.error('状态更新失败:', error)
                this.$message.error('状态更新失败')
                // 恢复原状态
                row.isEnable = row.isEnable === 1 ? 0 : 1
            }
        },

        // 监听 ruleType 变化，重建表单
        rebuildFormByRuleType(ruleType) {
            const template = this.ruleTypeTemplates[ruleType] || {};

            // 重置 ruleContent
            this.form.ruleContent = { ...template };

            // 根据规则类型设置默认的 dayMaxPoint
            if (['sign', 'dayMsgRank', 'weekMsgRank', 'monthMsgRank'].includes(ruleType)) {
                this.form.dayMaxPoint = -1; // 无限制
            } else {
                this.form.dayMaxPoint = 10; // 默认限制
            }

            // 重置其他相关字段
            this.form.pointDirect = 1;
            this.form.pointNum = 1;
        },

        // 根据规则类型过滤 ruleContent
        filterRuleContentByType(ruleType, ruleContent) {
            const validFields = {
                sign: ['signWord', 'deleteMemo', 'deleteTipMemo', 'signSuccessHtml', 'signRepeatHtml', 'signMsgType', 'signMsgBtnList'],
                textContent: ['msgLength'],
                photoContent: [],
                videoContent: [],
                stickerContent: [],
                dayMsgNum: ['awardRule', 'deleteMemo', 'awardHtml'],
                weekMsgNum: ['awardRule', 'deleteMemo', 'awardHtml'],
                monthMsgNum: ['awardRule', 'deleteMemo', 'awardHtml'],
                dayMsgRank: ['minMsgNum', 'awardRule'],
                weekMsgRank: ['minMsgNum', 'awardRule'],
                monthMsgRank: ['awardRule'] // 注意：这个没有 minMsgNum
            };

            const fields = validFields[ruleType] || [];
            const filtered = {};

            fields.forEach(field => {
                if (Object.prototype.hasOwnProperty.call(ruleContent, field)) {
                    filtered[field] = ruleContent[field];
                }
            });

            return filtered;
        },

        // 处理表单数据类型转换
        processFormData(form) {
            // 处理数字类型
            if (form.pointNum !== undefined) {
                form.pointNum = parseInt(form.pointNum) || 0;
            }
            if (form.isEnable !== undefined) {
                form.isEnable = parseInt(form.isEnable) || 0;
            }
            if (form.dayMaxPoint !== undefined) {
                form.dayMaxPoint = parseInt(form.dayMaxPoint) || -1;
            }

            // 处理 ruleContent 内部的数字
            if (form.ruleContent) {
                if (form.ruleContent.msgLength !== undefined) {
                    form.ruleContent.msgLength = parseInt(form.ruleContent.msgLength) || 0;
                }
                if (form.ruleContent.minMsgNum !== undefined) {
                    form.ruleContent.minMsgNum = String(form.ruleContent.minMsgNum || '0');
                }
                if (Array.isArray(form.ruleContent.awardRule)) {
                    form.ruleContent.awardRule.forEach(item => {
                        if (item.msgNum !== undefined) {
                            item.msgNum = String(item.msgNum || '');
                        }
                        if (item.minRank !== undefined) {
                            item.minRank = String(item.minRank || '');
                        }
                        if (item.maxRank !== undefined) {
                            item.maxRank = String(item.maxRank || '');
                        }
                        if (item.pointNum !== undefined) {
                            item.pointNum = String(item.pointNum || '');
                        }
                    });
                }
            }
        },

        async handleSubmit() {
            try {
                await this.$refs.formRef.validate();
                // 深拷贝，避免直接修改表单
                const finalForm = JSON.parse(JSON.stringify(this.form));

                // 根据规则类型过滤 ruleContent
                finalForm.ruleContent = this.filterRuleContentByType(
                    finalForm.ruleType,
                    finalForm.ruleContent
                );

                // 处理数据类型转换
                this.processFormData(finalForm);

                let response;
                if (this.dialogType === 'create') {
                    finalForm.userid = this.currentUserInfo.userId;
                    finalForm.groupid = this.currentUserInfo.groupId;
                    finalForm.userBot = this.currentUserInfo.userBot;
                    finalForm.createTime = Date.now();
                    if (!finalForm.userid || !finalForm.groupid || !finalForm.userBot) {
                        this.$message.error('用户信息不完整，请刷新页面后重试');
                        return;
                    }
                    response = await api.createPointsManager(finalForm);
                } else {
                    finalForm.groupid = this.currentUserInfo.groupId;
                    finalForm.userBot = this.currentUserInfo.userBot;
                    if (!finalForm.id) {
                        this.$message.error('规则ID丢失，请刷新页面后重试');
                        return;
                    }
                    response = await api.updatePointsManager(finalForm.id, finalForm);
                }
                if (response.data.code === 0) {
                    this.$message.success(this.dialogType === 'create' ? '创建成功' : '更新成功');
                    this.dialogVisible = false;
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '操作失败');
                }
            } catch (error) {
                console.error('=== handleSubmit 异常 ===');
                this.$message.error(error.response?.data?.message || error.message || '操作失败');
            }
        },


        handleImport() {
            this.importVisible = true
            this.jsonInput = ''
            this.previewCount = 0
            this.isFormatted = false
        },
        async handleJsonFile(file) {
            // 读取本地json文件内容并填充到textarea
            const reader = new FileReader();
            reader.onload = (e) => {
                this.jsonInput = e.target.result;
                // 自动处理文件内容
                this.processJsonInput(e.target.result);
            };
            reader.onerror = () => {
                this.$message.error('文件读取失败');
            };
            reader.readAsText(file);
            // 阻止el-upload自动上传
            return false;
        },
        processJsonInput(input) {
            if (!input || !input.trim()) {
                this.previewCount = 0;
                return;
            }
            try {
                const data = JSON.parse(input);
                let records = [];

                // 自动识别格式并提取数组
                if (data && typeof data === 'object' && data.data && Array.isArray(data.data.records)) {
                    records = data.data.records;
                } else if (Array.isArray(data.records)) {
                    records = data.records;
                } else if (Array.isArray(data)) {
                    records = data;
                }

                this.previewCount = records.length;

                if (records.length > 0) {
                    // 压缩显示数组数据
                    this.jsonInput = JSON.stringify(records);
                    this.isFormatted = false;
                    this.$message.success(`成功提取 ${records.length} 条数据`);
                } else {
                    this.$message.warning('未识别到有效的数据记录');
                }
            } catch (e) {
                this.previewCount = 0;
                // 如果不是有效JSON，保持原内容不变
            }
        },
        toggleJsonFormat() {
            if (!this.jsonInput) return;

            try {
                const data = JSON.parse(this.jsonInput);
                if (this.isFormatted) {
                    // 压缩显示
                    this.jsonInput = JSON.stringify(data);
                    this.isFormatted = false;
                } else {
                    // 格式化显示
                    this.jsonInput = JSON.stringify(data, null, 2);
                    this.isFormatted = true;
                }
            } catch (e) {
                this.$message.error('JSON 格式不正确');
            }
        },
        async confirmImport() {
            if (!this.jsonInput) {
                this.$message.warning('请粘贴或上传 JSON 数据');
                return;
            }
            let data;
            try {
                data = JSON.parse(this.jsonInput);
            } catch (e) {
                this.$message.error('JSON 格式不正确');
                return;
            }
            // 现在直接是数组数据
            let importData = data;
            if (!Array.isArray(data)) {
                this.$message.error('数据格式错误，请确保是数组格式');
                return;
            }

            // 添加用户信息
            const importPayload = {
                userBot: this.currentUserInfo.userBot,
                groupid: this.currentUserInfo.groupId,
                userid: this.currentUserInfo.userId,
                records: importData
            };

            this.importLoading = true;
            try {
                const response = await api.importPointsManager(importPayload);
                if (response.data.code === 0) {
                    this.$message.success(`成功导入 ${response.data.data.importedCount} 条签到规则！`);
                    this.importVisible = false;
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '导入失败');
                }
            } catch (error) {
                this.$message.error('导入失败，请检查数据格式或联系管理员。');
            } finally {
                this.importLoading = false;
            }
        },
        async handleExport() {
            try {
                this.loading = true
                const response = await api.exportPointsManager({
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                })
                if (response.data.code === 0) {
                    const exportData = response.data.data
                    this.exportToJson(exportData)
                    this.$message.success('导出成功')
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('导出失败:', error)
                this.$message.error('导出失败')
            } finally {
                this.loading = false
            }
        },

        // 导出为JSON文件
        exportToJson(exportData) {
            // 格式化JSON数据
            const jsonContent = JSON.stringify(exportData, null, 2)

            // 创建Blob对象
            const blob = new Blob([jsonContent], { type: 'application/json' })

            // 创建下载链接
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url

            // 生成文件名
            const filename = `轮播广告_${new Date().toISOString().split('T')[0]}.json`
            link.download = filename

            // 触发下载
            document.body.appendChild(link)
            link.click()

            // 清理
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        },
        getloacltime(row) {
            /////////把13位时间戳转换为 格式化时间
            return this.formatDateTime(row)
        },

        formatDateTime(dateTime) {
            if (!dateTime) return '-'
            const date = new Date(dateTime)
            return date.toLocaleString('zh-CN')
        },


        removeButtonRow(rowIndex) {
            this.form.ruleContent.signMsgBtnList.splice(rowIndex, 1)
        },
        addButton(rowIndex) {
            this.form.ruleContent.signMsgBtnList[rowIndex].push({ btnText: '', btnLink: '' })
        },
        removeButton(rowIndex, btnIndex) {
            this.form.ruleContent.signMsgBtnList[rowIndex].splice(btnIndex, 1)
            if (this.form.ruleContent.signMsgBtnList[rowIndex].length === 0) {
                this.form.ruleContent.signMsgBtnList.splice(rowIndex, 1)
                if (this.currentRowIndex === rowIndex) {
                    this.currentRowIndex = -1
                } else if (this.currentRowIndex > rowIndex) {
                    this.currentRowIndex--
                }
            }
        },
        editButton(rowIndex, btnIndex) {
            this.editingButtonRowIndex = rowIndex
            this.editingButtonIndex = btnIndex
            this.currentRowIndex = rowIndex
            const button = this.form.ruleContent.signMsgBtnList[rowIndex][btnIndex]
            this.buttonForm.text = button.btnText
            this.buttonForm.url = button.btnLink
            this.buttonDialogVisible = true
        },


        formatText(type) {
            const textarea = this.$refs.replaytextInput.$refs.textarea;
            if (!textarea) return;

            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const selectedText = this.form.msgContent.msgText.substring(start, end);
            let replacement = selectedText;
            let preSelection = 0;
            let postSelection = 0;

            switch (type) {
                case 'bold':
                    replacement = `**${selectedText}**`;
                    preSelection = 2;
                    postSelection = 2;
                    break;
                case 'italic':
                    replacement = `_${selectedText}_`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'strikethrough':
                    replacement = `~${selectedText}~`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'code':
                    replacement = `\`${selectedText}\``;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'link':
                    {
                        const url = prompt("请输入链接 URL:", "https://");
                        if (url) {
                            replacement = `[${selectedText}](${url})`;
                            preSelection = 1;
                            postSelection = url.length + 3 + (selectedText.length > 0 ? 0 : -selectedText.length);
                        } else {
                            return;
                        }
                        break;
                    }
            }

            this.form.msgContent.msgText = this.form.msgContent.msgText.substring(0, start) + replacement + this.form.msgContent.msgText.substring(end);

            this.$nextTick(() => {
                textarea.focus();
                if (selectedText.length === 0) {
                    const newCursorPos = start + preSelection;
                    textarea.setSelectionRange(newCursorPos, newCursorPos);
                } else {
                    const newStart = start + preSelection;
                    const newEnd = start + replacement.length - postSelection;
                    textarea.setSelectionRange(newStart, newEnd);
                }
            });
        },
        insertHtml(tag, closeTag) {
            if (this.isSourceMode) {
                // 源码模式：操作textarea
                const textarea = this.$refs.htmlTextarea.$refs.textarea;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.form.ruleContent.signSuccessHtml.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;

                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }

                this.form.ruleContent.signSuccessHtml = this.form.ruleContent.signSuccessHtml.substring(0, start) + replacement + this.form.ruleContent.signSuccessHtml.substring(end);

                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                // 可视化模式：使用document.execCommand
                const visualEditor = this.$refs.visualEditor;
                if (!visualEditor) return;

                visualEditor.focus();

                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }

                // 更新form数据
                this.form.ruleContent.signSuccessHtml = visualEditor.innerHTML;
            }
        },
        // 第二个富文本框的insertHtml方法
        insertHtmlRepeat(tag, closeTag) {
            if (this.isSourceMode) {
                // 源码模式：操作textarea
                const textarea = this.$refs.htmlTextareaRepeat.$refs.textarea;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.form.ruleContent.signRepeatHtml.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;

                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }

                this.form.ruleContent.signRepeatHtml = this.form.ruleContent.signRepeatHtml.substring(0, start) + replacement + this.form.ruleContent.signRepeatHtml.substring(end);

                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                // 可视化模式：使用document.execCommand
                const visualEditor = this.$refs.visualEditorRepeat;
                if (!visualEditor) return;

                visualEditor.focus();

                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }

                // 更新form数据
                this.form.ruleContent.signRepeatHtml = visualEditor.innerHTML;
            }
        },
        // 奖励提示富文本插入标签
        insertHtmlAward(tag, closeTag) {
            if (this.isSourceMode) {
                const textarea = this.$refs.htmlTextareaAward.$refs.textarea;
                if (!textarea) return;
                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.form.ruleContent.awardHtml.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;
                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }
                this.form.ruleContent.awardHtml = this.form.ruleContent.awardHtml.substring(0, start) + replacement + this.form.ruleContent.awardHtml.substring(end);
                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                const visualEditor = this.$refs.visualEditorAward;
                if (!visualEditor) return;
                visualEditor.focus();
                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }
                this.form.ruleContent.awardHtml = visualEditor.innerHTML;
            }
        },
        toggleMode() {
            this.isSourceMode = !this.isSourceMode;

            // 模式切换时同步内容
            if (!this.isSourceMode) {
                // 从源码模式切换到可视化模式
                this.$nextTick(() => {
                    this.setVisualEditorContent(this.form.ruleContent.signSuccessHtml || '');
                    this.setVisualEditorContentRepeat(this.form.ruleContent.signRepeatHtml || '');
                    this.setVisualEditorContentAward(this.form.ruleContent.awardHtml || '');
                });
            }
        },
        // 保存光标位置
        saveCaretPosition() {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                const preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(this.$refs.visualEditor);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                return preCaretRange.toString().length;
            }
            return 0;
        },

        // 恢复光标位置
        restoreCaretPosition(caretPos) {
            const editor = this.$refs.visualEditor;
            if (!editor) return;

            const selection = window.getSelection();
            const range = document.createRange();

            let charIndex = 0;
            let nodeStack = [editor];
            let node, foundStart = false;

            while (!foundStart && (node = nodeStack.pop())) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const nextCharIndex = charIndex + node.textContent.length;
                    if (caretPos >= charIndex && caretPos <= nextCharIndex) {
                        range.setStart(node, caretPos - charIndex);
                        range.setEnd(node, caretPos - charIndex);
                        foundStart = true;
                    }
                    charIndex = nextCharIndex;
                } else {
                    let i = node.childNodes.length;
                    while (i--) {
                        nodeStack.push(node.childNodes[i]);
                    }
                }
            }

            if (foundStart) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },
        handleVisualInput(event) {
            // 如果正在输入中文，不更新内容
            if (this.isComposing) {
                return;
            }

            // 获取编辑器的HTML内容
            const content = event.target.innerHTML;

            // 清除之前的定时器
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }

            // 使用防抖更新，避免频繁触发响应式更新
            this.updateTimer = setTimeout(() => {
                if (content !== this.form.ruleContent.signSuccessHtml) {
                    this.form.ruleContent.signSuccessHtml = content;
                }
            }, 300); // 300ms防抖
        },
        // 第二个富文本框的处理方法
        handleVisualInputRepeat(event) {
            // 如果正在输入中文，不更新内容
            if (this.isComposingRepeat) {
                return;
            }

            // 获取编辑器的HTML内容
            const content = event.target.innerHTML;

            // 清除之前的定时器
            if (this.updateTimerRepeat) {
                clearTimeout(this.updateTimerRepeat);
            }

            // 使用防抖更新，避免频繁触发响应式更新
            this.updateTimerRepeat = setTimeout(() => {
                if (content !== this.form.ruleContent.signRepeatHtml) {
                    this.form.ruleContent.signRepeatHtml = content;
                }
            }, 300); // 300ms防抖
        },
        handlePaste(event) {
            // 让浏览器处理粘贴，支持富文本粘贴
            // 不阻止默认行为，让contenteditable自然处理粘贴
            // 粘贴后会触发input事件，自动更新form
        },
        handlePasteRepeat(event) {
            // 让浏览器处理粘贴，支持富文本粘贴
            // 不阻止默认行为，让contenteditable自然处理粘贴
            // 粘贴后会触发input事件，自动更新form
        },
        handlePasteAward(event) {
            // 让浏览器处理粘贴，支持富文本粘贴
            // 不阻止默认行为，让contenteditable自然处理粘贴
            // 粘贴后会触发input事件，自动更新form
        },
        handleCompositionStart(event) {
            // 中文输入开始
            this.isComposing = true;
        },
        handleCompositionStartRepeat(event) {
            // 中文输入开始
            this.isComposingRepeat = true;
        },
        handleCompositionStartAward(event) {
            this.isComposingAward = true;
        },
        handleCompositionEnd(event) {
            // 中文输入结束，更新内容
            this.isComposing = false;

            const content = event.target.innerHTML;

            // 清除之前的定时器
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }

            // 中文输入结束时立即更新
            if (content !== this.form.ruleContent.signSuccessHtml) {
                this.form.ruleContent.signSuccessHtml = content;
            }
        },
        handleCompositionEndRepeat(event) {
            // 中文输入结束，更新内容
            this.isComposingRepeat = false;

            const content = event.target.innerHTML;

            // 清除之前的定时器
            if (this.updateTimerRepeat) {
                clearTimeout(this.updateTimerRepeat);
            }

            // 中文输入结束时立即更新
            if (content !== this.form.ruleContent.signRepeatHtml) {
                this.form.ruleContent.signRepeatHtml = content;
            }
        },
        handleCompositionEndAward(event) {
            this.isComposingAward = false;
            const content = event.target.innerHTML;
            if (this.updateTimerAward) clearTimeout(this.updateTimerAward);
            if (content !== this.form.ruleContent.awardHtml) {
                this.form.ruleContent.awardHtml = content;
            }
        },
        handleKeydown(event) {
            // 让浏览器处理所有按键，包括回车
            // contenteditable会自动处理换行，我们只需要在input事件中更新数据
        },
        handleKeydownRepeat(event) {
            // 让浏览器处理所有按键，包括回车
            // contenteditable会自动处理换行，我们只需要在input事件中更新数据
        },
        handleKeydownAward(event) {
            // 让浏览器处理所有按键，包括回车
            // contenteditable会自动处理换行，我们只需要在input事件中更新数据
        },
        // 手动设置可视化编辑器内容
        setVisualEditorContent(content) {
            if (this.$refs.visualEditor && !this.isSourceMode) {
                this.$refs.visualEditor.innerHTML = content || '';
            }
        },
        // 手动设置第二个可视化编辑器内容
        setVisualEditorContentRepeat(content) {
            if (this.$refs.visualEditorRepeat && !this.isSourceMode) {
                this.$refs.visualEditorRepeat.innerHTML = content || '';
            }
        },
        // 手动设置奖励提示富文本内容
        setVisualEditorContentAward(content) {
            if (this.$refs.visualEditorAward && !this.isSourceMode) {
                this.$refs.visualEditorAward.innerHTML = content || '';
            }
        },
        // 显示添加按钮对话框
        showAddButtonDialog(rowIndex) {
            if (rowIndex !== -1 && this.form.ruleContent.signMsgBtnList[rowIndex].length >= 5) {
                this.$message.warning('每一行最多允许5个按钮');
                return;
            }
            this.editingButtonRowIndex = -1;
            this.editingButtonIndex = -1;
            this.currentRowIndex = rowIndex;
            this.buttonForm = { btnText: '', btnLink: '' };
            this.buttonDialogVisible = true;
        },
        // 获取对话框标题
        getDialogTitle() {
            if (this.editingButtonIndex !== -1) {
                const rowNum = this.editingButtonRowIndex + 1;
                const btnNum = this.editingButtonIndex + 1;
                return `编辑第${rowNum}行第${btnNum}个按钮`;
            } else if (this.currentRowIndex === -1) {
                return '新增一行按钮';
            } else {
                if (this.form.ruleContent.signMsgBtnList[this.currentRowIndex]) {
                    const rowNum = this.currentRowIndex + 1;
                    const btnNum = this.form.ruleContent.signMsgBtnList[this.currentRowIndex].length + 1;
                    return `第${rowNum}行第${btnNum}个按钮`;
                } else {
                    return '新增一行按钮';
                }
            }
        },
        // 确认添加按钮
        confirmAddButton() {
            this.$refs.buttonFormRef.validate((valid) => {
                if (!valid) return;
                const buttonData = {
                    btnText: this.buttonForm.text.trim(),
                    btnLink: this.buttonForm.url.trim()
                };
                if (this.editingButtonIndex !== -1) {
                    this.form.ruleContent.signMsgBtnList[this.editingButtonRowIndex][this.editingButtonIndex] = buttonData;
                    this.$message.success('按钮编辑成功');
                    this.editingButtonRowIndex = -1;
                    this.editingButtonIndex = -1;
                } else if (this.currentRowIndex === -1) {
                    this.form.ruleContent.signMsgBtnList.push([buttonData]);
                    this.$message.success('按钮添加成功');
                } else {
                    if (this.form.ruleContent.signMsgBtnList[this.currentRowIndex]) {
                        this.form.ruleContent.signMsgBtnList[this.currentRowIndex].push(buttonData);
                        this.$message.success('按钮添加成功');
                    } else {
                        this.form.ruleContent.signMsgBtnList.push([buttonData]);
                        this.$message.success('按钮添加成功');
                    }
                }
                this.buttonDialogVisible = false;
            });
        },

        // 拖拽相关方法
        handleDragStart(rowIndex) {
            this.draggedRowIndex = rowIndex;
        },

        handleDragEnd() {
            this.draggedRowIndex = null;
        },

        handleDragOver(event) {
            event.preventDefault();
        },

        handleDrop(event, targetRowIndex) {
            event.preventDefault();
            event.stopPropagation();
            if (this.draggedRowIndex === null || this.draggedRowIndex === targetRowIndex) {
                return;
            }
            const fromIndex = this.draggedRowIndex;
            const toIndex = targetRowIndex;
            const newRows = [...this.form.ruleContent.signMsgBtnList];
            const draggedRow = newRows[fromIndex];
            newRows.splice(fromIndex, 1);
            newRows.splice(toIndex, 0, draggedRow);
            this.form.ruleContent.signMsgBtnList = newRows;
            this.$nextTick(() => {
                this.$forceUpdate();
            });
            this.$message.success(`第${fromIndex + 1}行已移动到第${toIndex + 1}行`);
        },


        showMediaGroupDialog() {
            // 复制当前的 mediaGroup 到临时变量进行编辑
            if (this.form.msgContent.mediaGroup && this.form.msgContent.mediaGroup.length > 0) {
                this.tempMediaGroup = JSON.parse(JSON.stringify(this.form.msgContent.mediaGroup));
            } else {
                // 如果没有数据，初始化为空数组
                this.tempMediaGroup = [];
            }
            this.mediaGroupDialogVisible = true;
        },
        cancelMediaGroupEdit() {
            this.mediaGroupDialogVisible = false;
            // 重置临时数据
            this.tempMediaGroup = [];
        },
        confirmMediaGroupEdit() {
            // 过滤掉空的条目
            const validItems = this.tempMediaGroup.filter(item =>
                item.mediaType && item.fileUrl && item.fileUrl.trim()
            );

            // 保存到 form 中
            if (!this.form.msgContent) {
                this.form.msgContent = { msgText: '', mediaGroup: [] };
            }
            this.form.msgContent.mediaGroup = validItems;

            this.mediaGroupDialogVisible = false;
            this.$message.success('媒体组保存成功');
        },
        addMediaItem() {
            this.tempMediaGroup.push({ mediaType: 'photo', fileUrl: '' });
        },
        removeMediaItem(index) {
            this.tempMediaGroup.splice(index, 1);
        },
        getRuleTypeLabel(type) {
            return this.ruleTypeLabelMap[type] || type;
        }
    },

    mounted() {

        if (this.$store.state.user) {
            this.loadUserInfo(this.$store.state.user);
            this.fetchData()
            this.fetchSetting();
        }
    }
}
</script>

<style scoped>
.auto-reply {
    padding: 20px;
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.stats-section {
    margin-bottom: 20px;
}

.stats-card {
    text-align: center;
}

.stats-item {
    padding: 10px;
}

.stats-value {
    font-size: 24px;
    font-weight: bold;
    color: #409eff;
    margin-bottom: 5px;
}

.stats-label {
    font-size: 14px;
    color: #666;
}

.keyword-display {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.keyword-desc {
    margin-top: 5px;
}

.reply-content {
    max-width: 300px;
    word-break: break-all;
}

.media-url {
    margin-top: 5px;
    padding: 5px;
    background: #f5f5f5;
    border-radius: 4px;
}

.advanced-settings {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}

.upload-demo {
    text-align: center;
}

.el-upload__tip {
    color: #666;
    font-size: 12px;
    margin-top: 10px;
}

.placeholder-description {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
}

.button-input-area {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    min-height: 60px;
    margin-bottom: 10px;
}

.button-row {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.button-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.button-controls {
    display: flex;
    gap: 10px;
}

.delete-row-btn {
    background-color: #fee;
    color: #f56c6c;
    border-color: #fde2e2;
}

.delete-row-btn:hover {
    background-color: #fdd;
    color: #f23c3c;
}

.other-settings {
    margin-top: 15px;
}

.setting-label {
    color: var(--el-text-color-regular);
    margin-right: 12px;
}

.form-label-with-icon {
    display: flex;
    align-items: center;
    gap: 4px;
}

.required-asterisk {
    color: var(--el-color-danger);
    margin-right: 4px;
}

.condition-input-group {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.reply-content-head {
    display: flex;
    align-items: flex-start;
}

.keyword-tags-input {
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    border: 1px solid var(--el-border-color);
    border-radius: 4px;
    padding: 2px 8px;
    min-height: 32px;
    max-width: 350px;
}

.keyword-new-tag-input {
    border: none;
    outline: none;
    flex-grow: 1;
    min-width: 80px;
    background-color: transparent;
}

.html-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: white;
    max-width: 460px;
}

.html-textarea {
    width: 100%;
    max-width: 460px;
}

.html-textarea :deep(.el-textarea__inner) {
    max-height: 200px;
    min-height: 120px;
    resize: vertical;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.html-toolbar {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-bottom: 1px solid #dcdfe6;
    background: #f5f7fa;
    flex-wrap: wrap;
    gap: 4px;
}

.html-toolbar button {
    padding: 4px 8px;
    border: 1px solid #dcdfe6;
    background: white;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s;
    min-width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.html-toolbar button:hover:not(:disabled) {
    background: #ecf5ff;
    border-color: #409eff;
}

.html-toolbar button.is-active {
    background: #409eff;
    color: white;
    border-color: #409eff;
}

.html-toolbar button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f5f7fa;
}

.html-toolbar .divider {
    margin: 0 8px;
    color: #dcdfe6;
}

.editor-content-area {
    border: 1px solid #dcdfe6;
    border-top: none;
    border-radius: 0 0 4px 4px;
}

.visual-editor {
    min-height: 50px;
    max-height: 200px;
    height: 200px;
    padding: 12px;
    outline: none;
    cursor: text;
    line-height: 1.6;
    font-size: 14px;
    background: white;
    border-radius: 0 0 4px 4px;
    direction: ltr;
    text-align: left;
    unicode-bidi: normal;
    overflow-y: auto;
    word-wrap: break-word;
    overflow-wrap: break-word;
    box-sizing: border-box;
}

.visual-editor:focus {
    outline: none;
}

.visual-editor p {
    margin: 8px 0;
}

.visual-editor p:first-child {
    margin-top: 0;
}

.visual-editor p:last-child {
    margin-bottom: 0;
}

.visual-editor h1,
.visual-editor h2,
.visual-editor h3 {
    margin: 16px 0 8px 0;
    font-weight: bold;
}

.visual-editor h1 {
    font-size: 1.5em;
}

.visual-editor h2 {
    font-size: 1.3em;
}

.visual-editor ul,
.visual-editor ol {
    padding-left: 20px;
    margin: 8px 0;
}

.visual-editor li {
    margin: 4px 0;
}

.visual-editor strong,
.visual-editor b {
    font-weight: bold;
}

.visual-editor em,
.visual-editor i {
    font-style: italic;
}

.visual-editor u {
    text-decoration: underline;
}

.visual-editor[contenteditable]:empty:before {
    content: "请输入提示消息...";
    color: #c0c4cc;
    font-style: italic;
}

.reply-type-horizontal {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
}

.type-select-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    min-width: 250px;
}

.media-url-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 350px;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #409eff;
    animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.reply-type-dropdown {
    max-height: 200px;
    overflow-y: auto;
    z-index: 9999;
}

/* 按钮行列表样式 */
.button-rows-list {
    margin-bottom: 2px;
}

.button-row-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 2px;
    margin-left: 35px;
    /* 与新增一行按钮对齐 */
    border-radius: 6px;
    padding: 6px;
    transition: all 0.3s ease;
}

.button-row-wrapper.drag-over {
    background-color: #f0f9ff;
    border: 2px dashed #1890ff;
    transform: scale(1.02);
}

.gray-buttons-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    /* 不允许换行 */
    width: 480px;
    /* 与新增一行按钮宽度一致 */
    flex-shrink: 0;
    /* 不允许收缩 */
}

.button-item {
    background: #a8a8a8;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    border: none;
    cursor: default;
    white-space: nowrap;
    /* 文字不换行 */
    flex: 1;
    /* 弹性宽度，平均分配空间 */
    min-width: 0;
    /* 允许收缩到内容宽度 */
    overflow: hidden;
    /* 防止内容溢出 */
    text-overflow: ellipsis;
    /* 文字过长时显示省略号 */
    position: relative;
    /* 为操作按钮定位提供参考 */
    transition: all 0.3s ease;
    height: 36px;
    /* 确保与蓝色按钮高度一致 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.button-item:hover {
    background: #909399;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.button-actions {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 2;
}

.button-item:hover .button-actions {
    opacity: 1;
}

.button-action-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.edit-icon {
    background: #409eff;
}

.edit-icon:hover {
    background: #66b1ff;
    transform: scale(1.1);
}

.delete-icon {
    background: #f56c6c;
}

.delete-icon:hover {
    background: #f78989;
    transform: scale(1.1);
}

.button-action-icon .el-icon {
    font-size: 12px;
    color: white;
}

.add-button-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.add-to-row-button {
    background: #1890ff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.3s ease;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.add-to-row-button:hover {
    background: #40a9ff;
}

/* 新增按钮样式 */
.button-controls {
    display: flex;
    align-items: center;
    padding: 0;
}

.add-row-button {
    border: 1px dashed #d9d9d9;
    background: #fff;
    color: #666;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
    outline: none;
    min-width: 480px;
    height: 36px;
    margin-left: 35px;
}

.add-row-button:hover {
    border-color: #1890ff;
    color: #1890ff;
}

.drag-icon-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: grab;
    user-select: none;
}

.drag-icon-container:active {
    cursor: grabbing;
}

.drag-icon {
    font-size: 16px;
    color: #8c8c8c;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s ease;
}

.drag-icon-container:hover .drag-icon {
    color: #1890ff;
}

.drag-icon-container[draggable="true"] {
    cursor: grab;
}

.drag-icon-container[draggable="true"]:active {
    cursor: grabbing;
}

/* 变量说明样式 */
.variable-help-text {
    margin-top: -10px;
    margin-bottom: 20px;
    margin-left: 120px;
    max-width: 430px;
    /* 与表单标签对齐 */
    padding: 12px 16px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.6;
    color: #6c757d;
}

.variable-item {
    display: inline;
}

.variable-help-text code {
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #bbdefb;
}

.carousel-tabs .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 40px 12px 40px;
}

.carousel-banner {
    background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%);
    color: #fff;
    border-radius: 18px 18px 0 0;
    padding: 36px 36px 18px 36px;
    text-align: left;
    margin-bottom: -18px;
    box-shadow: 0 4px 24px rgba(100, 100, 100, 0.10);
}

.carousel-banner-title {
    font-size: 2.2rem;
    font-weight: bold;
    letter-spacing: 2px;
}

.carousel-banner-desc {
    font-size: 1.1rem;
    opacity: 0.90;
    margin-top: 10px;
}

.carousel-setting-card {
    border-radius: 18px;
    box-shadow: 0 2px 18px rgba(100, 100, 100, 0.10);
    padding: 38px 28px 28px 28px;
    margin-top: 0;
}

.form-section-title {
    font-size: 1.15rem;
    font-weight: 600;
    margin: 28px 0 10px 0;
    color: #6a82fb;
    letter-spacing: 1px;
}

.big-switch :deep(.el-switch__core) {
    width: 56px !important;
    height: 28px !important;
    border-radius: 18px !important;
}

.big-switch :deep(.el-switch__action) {
    width: 28px !important;
    height: 28px !important;
}

.big-submit-btn {
    width: 280px;
    background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%);
    border: none;
    border-radius: 10px;
    font-size: 1.15rem;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(252, 92, 125, 0.12);
    padding: 14px 0;
    margin-top: 18px;
}

/* 拖拽上传样式 */
.json-upload-drag {
    width: 100%;
}

.json-upload-drag :deep(.el-upload-dragger) {
    width: 100%;
    height: 120px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.json-upload-drag :deep(.el-upload-dragger:hover) {
    border-color: #409eff;
    background: #f0f9ff;
}

.json-upload-drag :deep(.el-upload-dragger.is-dragover) {
    border-color: #409eff;
    background: #e6f7ff;
    transform: scale(1.02);
}

.json-upload-drag :deep(.el-icon--upload) {
    font-size: 28px;
    color: #c0c4cc;
    margin-bottom: 8px;
    transition: color 0.3s ease;
}

.json-upload-drag :deep(.el-upload-dragger:hover .el-icon--upload) {
    color: #409eff;
}

.json-upload-drag :deep(.el-upload__text) {
    color: #606266;
    font-size: 14px;
    text-align: center;
    line-height: 1.5;
}

.json-upload-drag :deep(.el-upload__text em) {
    color: #409eff;
    font-style: normal;
    font-weight: bold;
}

.json-upload-drag :deep(.el-upload__tip) {
    color: #888;
    font-size: 12px;
    line-height: 1.6;
    margin-top: 8px;
    text-align: center;
}

.media-group-manager {
    display: flex;
    flex-direction: column;
    gap: 15px;
    min-height: 200px;
}

.media-item {
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.media-item-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.media-index {
    font-weight: bold;
    color: #409eff;
    min-width: 30px;
}

.add-media-section {
    display: flex;
    justify-content: center;
    padding: 20px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
}

.add-media-section:hover {
    border-color: #409eff;
    background: #f0f9ff;
}

.media-management-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
}
</style>